import ResourceAvailability from './ResourceAvailability';

export default ResourceAvailability;
